export default __webpack_public_path__ + "media/images/images_v2/blue-b0d1e5a1022ed25e5bd5a46f22ad05bd.png";